export default "__VITE_ASSET__D$$uwKwT__"